import { create } from 'zustand'
import { ChatMessageTelemetry } from '../types'
import { useChatManagerStore } from './use-chat-manager-store'

type TelemetryPanelStore = {
  isPanelOpen: boolean
  chatTelemetry: ChatMessageTelemetry | null

  togglePanel: (open?: boolean | undefined) => void
  setChatTelemetry: (telemetry: ChatMessageTelemetry | null) => void
}

export const useTelemetryPanelStore = create<TelemetryPanelStore>((set, get) => ({
  isPanelOpen: false,
  chatTelemetry: null,

  togglePanel: (open) => {
    const value = open ?? !get().isPanelOpen;
    if (get().isPanelOpen === value) return;
    set({ isPanelOpen: value })
  },
  setChatTelemetry: (chatTelemetry) => {
    set({ chatTelemetry });
    clearTelemetryOnChatIdMisMatch();
  },
}));

const clearTelemetryOnChatIdMisMatch = () => {
  const telemetry = useTelemetryPanelStore.getState().chatTelemetry;
  if (typeof telemetry?.chatId !== 'undefined') {
    const id = useChatManagerStore.getState().chatId;

    if (typeof id !== 'undefined' && telemetry?.chatId !== id) {
      useTelemetryPanelStore.setState({ chatTelemetry: null });
      useTelemetryPanelStore.getState().togglePanel(false);
    }
  }
}

// we need to subscribe to the useAccountMatterStore to see accountId/matterId changes
const subscribeToChatId = () => {
  const unsubscribe = useChatManagerStore.subscribe(
    (state, prevState) => {
      if (state.chatId !== prevState.chatId) {
        clearTelemetryOnChatIdMisMatch();
      }
    }
  );

  // Return cleanup function
  return () => {
    unsubscribe();
  };
}

export const initTelemetryPanelStore = () => {
  const disableChatIdSub = subscribeToChatId();
  clearTelemetryOnChatIdMisMatch();
  return [disableChatIdSub];
}
